// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blissey: PokeData = {
  "id": 242,
  "name": "blissey",
  "height": 15,
  "weight": 468,
  "base_experience": 608,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "growl",
    "sing",
    "minimize",
    "defense-curl",
    "light-screen",
    "egg-bomb",
    "soft-boiled",
    "sweet-kiss",
    "charm",
    "helping-hand",
    "refresh",
    "covet",
    "calm-mind",
    "healing-wish",
    "fling",
    "copycat",
    "last-resort",
    "echoed-voice",
    "heal-pulse",
    "bestow",
    "disarming-voice",
    "draining-kiss",
    "fairy-wind",
    "baby-doll-eyes",
    "life-dew"
  ],
  "moves": [
    "tackle",
    "growl",
    "sweet-kiss",
    "refresh",
    "calm-mind",
    "healing-wish",
    "life-dew",
    "scary-face",
    "quick-attack",
    "leer",
    "supersonic",
    "body-slam",
    "purification"
  ],
  "evolution_chain": {
    "id": 51,
    "item": {
      "name": "luck-incense"
    },
    "species": [
      {
        "name": "happiny",
        "order": 126,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "chansey",
        "order": 127,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 440,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blissey",
        "order": 128,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 113,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 223,
    "speed": 75,
    "ability_power": 102
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
